import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Container, Header, Form, Button } from 'semantic-ui-react';
import { Formik, Field, Form as FormikForm } from 'formik';
import { FormikInputComponent } from '../../../utilities/formUtils';
import userACL from '../../../store/access'  
import moment  from 'moment'
import v4 from 'uuid';

// import UserDropdown from '../../users/components/userDropdown'


const TestForm = (props) => {

    const dispatch = useDispatch()
    const input = FormikInputComponent

    const saveTest = (values, resetForm) => {
        if (props.match.path === '/test/create') {
            userACL.atCreate(values)
            // dispatch(createTest(values))
            resetForm()
        }
        if (props.match.path === '/test/edit/:id') {
            userACL.atUpdate(values)
            // dispatch(editTest(values))
            props.history.push(`/test/list`)
        }
    }

    return (
        <Container >
            <Header as='h1'>Test</Header>
            <Formik id="testForm" size="large" width={5}
                // initialValues={test}
                // validationSchema={testSchema}
                onSubmit={(values, {resetForm}) => saveTest(values, resetForm)}
                render={({ handleSubmit, onChange, values, handleChange }) => (
                    <Form as={FormikForm} size="small" className="CustomeForm" width={5} onSubmit={handleSubmit}>
                        <Form.Group widths={3}>
                            <Field name="key" component={input} placeholder="Key"></Field>
                            <Field name="name" component={FormikInputComponent} placeholder="Name"></Field>
                            <Field name="short_name" component={FormikInputComponent} placeholder="Short Name"></Field>  
                        </Form.Group> 
                        <Form.Group widths={3}> 
                            <Field name="location" component={FormikInputComponent} placeholder="Location"></Field>
                            <Field name="email" component={FormikInputComponent} placeholder="Email"></Field>
                        </Form.Group>

                        <Button type="submit" size="medium blue" className="CustomeBTN"> Save </Button>
                    </Form>
                )}
            />
        </Container>
    )
}

export default TestForm;